<template>
  <div id="inputSenha">
    <div class="input-group">
      <input
        v-if="type === 'text'"
        type="text"
        id="__ncm_input_senha_text"
        class="form-control"
        :placeholder="placeholder"
        :disabled="disabled"
        @keyup="onKeyUp"
      />
      <input
        v-if="type === 'password'"
        type="password"
        id="__ncm_input_senha_password"
        class="form-control"
        :placeholder="placeholder"
        :disabled="disabled"
        @keyup="onKeyUp"
      />
      <span class="input-group-btn">
        <button
          type="button"
          class="btn btn-default"
          :title="type === 'password' ? 'Ver senha' : 'Ocultar Senha'"
          v-on:click="showPassword"
        >
          <i
            class="fa fa-eye"
            :class="{ 'fa fa-eye': type === 'password', 'fa fa-eye-slash': type === 'text' }"
          ></i>
        </button>
      </span>
    </div>
  </div>
</template>
<script type="text/javascript">
import md5 from 'md5'

export default {
  name: 'input-senha',
  props: {
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String
    }
  },
  data() {
    return {
      type: 'password',
      currentValue: ''
    }
  },
  mounted() {},
  methods: {
    showPassword() {
      this.type = this.type === 'text' ? 'password' : 'text'
      this.inputFocus()
    },

    inputFocus() {
      setTimeout(() => {
        this.$el.querySelector('#__ncm_input_senha').focus()
      }, 100)
    },

    onKeyUp(event) {
      const value = event.target.value
      this.$emit('input', value)
      this.$emit('input-md5', value ? md5(value) : '')
    }
  }
}
</script>
